// The package's only error class. Each rule module declares its own code
// union. Nothing is appended to a shared list.

export class ContestEngineInputError<
  TCode extends string = string,
> extends Error {
  public readonly code: TCode;

  constructor(args: { code: TCode; message: string }) {
    super(args.message);
    this.name = "ContestEngineInputError";
    this.code = args.code;
  }
}
